import Vue from 'vue';
import Router from 'vue-router';
import goTo from 'vuetify/es5/services/goto';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/brands',
      name: 'brands',
      component: () => import(/* webpackChunkName: "brands" */ './views/Brand.vue'),
    },
    {
      path: '/influencers',
      name: 'influencers',
      component: () => import(/* webpackChunkName: "influencers" */ './views/Influencer.vue'),
    },
    {
      path: '/insights',
      name: 'insights',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Insights.vue'),
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import(/* webpackChunkName: "influencers" */ './views/Pricing.vue'),
    },
    {
      path: '/support',
      name: 'support',
      component: () => import(/* webpackChunkName: "support" */ './views/Support.vue'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/careers',
      name: 'careers',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Careers.vue'),
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ContactUs.vue'),
    },
    {
      path: '/news',
      name: 'news',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/News.vue'),
    },
    {
      path: '/news/article/:id',
      name: 'article',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Article.vue'),
    },
    {
      path: '/careers/job/:id',
      name: 'job',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Job.vue'),
    },
    {
      path: '/c/:id',
      name: 'campaigns',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Campaigns'),
    },
    {
      path: '/get-started',
      name: 'get-started',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/GetStart.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy policy',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PrivacyPolicy.vue'),
    },
    {
      path: '/terms-of-use',
      name: 'Terms of Use',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Terms.vue'),
    },
    {
      // catch all 404 - define at the very end
      path: '*',
      name: '404',
      component: () => import('./views/404.vue'),
    },
  ],
});
